import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, query, where, orderBy, onSnapshot } from "firebase/firestore";
import { Link } from 'react-router-dom';

const MyReports = () => {
  const [myReports, setMyReports] = useState([]);

  useEffect(() => {
    if (auth.currentUser) {
      const q = query(
        collection(db, "ihbarlar"),
        where("kullaniciEmail", "==", auth.currentUser.email),
        orderBy("zaman", "desc")
      );
      const unsubscribe = onSnapshot(q, (snapshot) => {
        const rpts = [];
        snapshot.forEach((doc) => rpts.push({ id: doc.id, ...doc.data() }));
        setMyReports(rpts);
      });
      return () => unsubscribe();
    }
  }, []);

  return (
    // SCROLL KİLİDİ AÇILDI
    <div className="fixed inset-0 w-full h-full overflow-y-auto bg-slate-50 z-50 pb-20">
      <div className="max-w-4xl mx-auto py-10 px-6 min-h-full">
        
        <div className="flex justify-between items-center mb-10 bg-white p-6 rounded-3xl shadow-sm border border-slate-100">
          <div>
            <h1 className="text-2xl font-black text-slate-900 uppercase italic tracking-tighter">İhbarlarım</h1>
            <p className="text-slate-400 text-xs font-bold uppercase tracking-widest">Gönderdiğiniz tüm kayıtlar</p>
          </div>
          <Link to="/" className="bg-slate-800 text-white px-6 py-3 rounded-xl font-bold text-sm shadow-lg active:scale-95 transition-all">
            Haritaya Dön
          </Link>
        </div>

        <div className="space-y-4">
          {myReports.length === 0 ? (
            <div className="text-center p-20 bg-white rounded-3xl border-2 border-dashed border-slate-200 text-slate-400 font-bold uppercase">Henüz bir ihbarınız bulunmuyor.</div>
          ) : (
            myReports.map(report => (
              <div key={report.id} className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex justify-between items-center">
                <div>
                  <p className="text-xs font-black text-red-500 uppercase tracking-widest mb-1">{report.tip}</p>
                  <p className="text-sm font-bold text-slate-800 italic">
                    {report.zaman ? new Date(report.zaman.seconds * 1000).toLocaleString('tr-TR') : '-'}
                  </p>
                </div>
                <div className={`px-4 py-2 rounded-full text-[10px] font-black uppercase ${
                  report.durum === 'Bekliyor' ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700'
                }`}>
                  {report.durum}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default MyReports;